module.exports = __webpack_public_path__ + "img/big3-16.980a52fc.jpg";